import { useEffect, useState } from 'react'

import { getBaseState, transformEventDataToFormState } from '../helpers'

const getReminderBaseState = (t) => ({
  building: null,
  eventName: '',
  description: '',
  location: '',
  repeatable: false,
  setupAutomatedReminders: false,
  rsvpd: false,
  rsvpdTime: null,
  nonRsvpd: false,
  nonRsvpdTime: null,
  schedulerType: { value: 'none', label: t('create-event:helpers.frequencyOptions.doesNotRepeat') },
  image: undefined,
  pdf: undefined,
  imagesDatabaseOpen: false,
})

export const useGetReminderFormState = (eventData, editMode, buildingId, buildingOptions, t) => {
  const [formState, setFormState] = useState(() =>
    editMode ? transformEventDataToFormState(eventData) : getBaseState(getReminderBaseState(t)),
  )
  const { building } = formState

  useEffect(() => {
    if (!building && buildingId) {
      setFormState((prev) => ({
        ...prev,
        building: buildingOptions.find((buildingToFind) => buildingToFind.id === buildingId),
      }))
    }
  }, [buildingOptions, buildingId, building])

  return [formState, setFormState]
}
